import { colorSet } from '@theme';
import { Text } from '..';
import { PlusPrimaryIcon } from '@assets/iconComponents';

interface IAIRecommendedTagProps {
  recommendedTag?: string;
  onClick: () => void;
}

export const AIRecommendedTag = (props: IAIRecommendedTagProps) => {
  const { recommendedTag, onClick } = props;

  return (
    <div
      onClick={onClick}
      style={{
        height: 28,
        border: `1px solid ${colorSet.primaryMain}`,
        borderRadius: '6px',
        padding: '0px 10px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        cursor: 'pointer'
      }}
    >
      <Text variant="body1" color={colorSet.primaryMain}>
        {recommendedTag}
      </Text>

      <PlusPrimaryIcon style={{ width: 16, height: 16, marginLeft: '2px' }} />
    </div>
  );
};
